/* eslint-disable import/prefer-default-export */
import { Attempt } from '../../models';
import { Results } from './models';
import { NOTE_KEYS } from '../Arcade/components/GameForeground/constants/layout';

export const getResults = (
  attempts: Attempt[],
  health: number,
  gotSpecial: boolean
): Results => {
  const results = {
    points: 0,
    health,
    damage: 0,
    perfect: 0,
    good: 0,
    okay: 0,
    bad: 0,
    awful: 0,
    pre: 0,
    miss: 0,
    wrong: 0,
    delta: 0,
    deltaSquared: 0,
    hits: 0,
    gotSpecial,
  };

  attempts.forEach((attempt) => {
    results.points += attempt.points;
    results.damage += attempt.damage > 0 ? attempt.damage : 0;
    results[attempt.rating] += 1;
    if (attempt.rating !== NOTE_KEYS.miss) {
      results.delta += attempt.delta;
      results.deltaSquared += attempt.delta ** 2;
      results.hits += 1;
    }
  });

  return results;
};
